// extracted by mini-css-extract-plugin
export default {"window":"CZHINRaN"};